var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 3.2,
    height: 10,
    rx: 0.8,
    transform: "rotate(-90 7 23)",
    fill: "#FFB52B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19.2,
    width: 3.2,
    height: 10,
    rx: 0.8,
    transform: "rotate(-90 7 19.2)",
    fill: "#FFB52B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15.4,
    width: 3.2,
    height: 10,
    rx: 0.8,
    transform: "rotate(-90 7 15.4)",
    fill: "#FFB52B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 22,
    height: 14,
    rx: 3,
    transform: "rotate(-90 5 25)",
    stroke: "#249DFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L8 1C8 0.447715 8.44772 0 9 0L15 0C15.5523 0 16 0.447715 16 1L16 2L8 2Z",
    fill: "#249DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryYellow);
export default __webpack_public_path__ + "static/media/battery-yellow.fb08e29b6946e0c3d0c5b3902eaf48cc.svg";
export { ForwardRef as ReactComponent };